import { FC, useState } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useCookies } from 'react-cookie';

import { XIQ_ONLINE_URL } from 'constants/index';
import { getCSRFToken, setRedirectionPath } from 'utils';

interface PrivateRouteProps {
  component: FC;
  path: string;
  exact?: boolean;
}

export const PrivateRoute: FC<PrivateRouteProps> = (props) => {
  const [hostName] = useState(window.location.hostname);
  const [cookies] = useCookies();
  const isLogout = cookies?.isLogout;
  const csrfToken = getCSRFToken();

  if (isLogout && isLogout !== '1' && csrfToken) {
    return <Route path={props.path} exact={props.exact} component={props.component} />;
  } else if (hostName !== 'localhost') {
    setRedirectionPath();
    window.location.href = `${XIQ_ONLINE_URL}auth/login?redirectURL=${window.location.origin}`;
  }
  return <Redirect to={'/'} />;
};
